import { Model } from "./Model";

export class Note extends Model {
  static required = ["content"];

  constructor(parameters) {
    super(Note.required, parameters);
  }
}
